import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import {
  REACT_APP_FEATURE_FLAG_BUYER_ACTIVITIES_ENABLED,
  REACT_APP_FEATURE_FLAG_DNI_TEST_INPUT_ENABLED,
  REACT_APP_FEATURE_FLAG_FOREIGN_AUTHORITY_ENABLED,
  REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN,
  REACT_APP_FEATURE_FLAG_REGISTER_WIZARD,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS,
  REACT_APP_FEATURE_FLAG_UNIQUE_PASS
} from '../../config/settings/environment'

/**
 * The ProtectByFeatures' component.
 */
const ProtectByFeatures = props => {
  const { children, fallback, redirectTo, rule } = props
  const navigate = useNavigate()
  const features = {
    'com.buyer/activities':
      REACT_APP_FEATURE_FLAG_BUYER_ACTIVITIES_ENABLED === true ||
      REACT_APP_FEATURE_FLAG_BUYER_ACTIVITIES_ENABLED === 'true',
    'com.buyer/dni.test.input':
      REACT_APP_FEATURE_FLAG_DNI_TEST_INPUT_ENABLED === true ||
      REACT_APP_FEATURE_FLAG_DNI_TEST_INPUT_ENABLED === 'true',
    'com.buyer/foreign.authority':
      REACT_APP_FEATURE_FLAG_FOREIGN_AUTHORITY_ENABLED === true ||
      REACT_APP_FEATURE_FLAG_FOREIGN_AUTHORITY_ENABLED === 'true',
    'com.buyer/recovery.admin':
      REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN === true || REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN === 'true',
    'com.buyer/register.wizard':
      REACT_APP_FEATURE_FLAG_REGISTER_WIZARD === true || REACT_APP_FEATURE_FLAG_REGISTER_WIZARD === 'true',
    'com.buyer/taxes.key.checks':
      REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === true || REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === 'true',
    'com.buyer/unique.pass':
      REACT_APP_FEATURE_FLAG_UNIQUE_PASS === true || REACT_APP_FEATURE_FLAG_UNIQUE_PASS === 'true'
  }

  const result = rule(features)

  if (!result && redirectTo) {
    navigate(redirectTo, { replace: true })
  }

  if (!result) {
    return fallback(features)
  }

  return <>{children}</>
}

ProtectByFeatures.defaultProps = {
  fallback: () => null,
  redirectTo: '',
  rule: () => true
}
ProtectByFeatures.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  redirectTo: PropTypes.string,
  rule: PropTypes.func
}

export default ProtectByFeatures
